import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { useSelectItemIds } from '@anytag/shared-hooks';
import { AutoManagedCampaignInfoPayload } from '@anytag/graphql';
import { ActionBar } from './ActionBar';
import { useAutoManagedCampaignsTable } from './hooks';

export type AutoManagedCampaignsListProps = TableData<AutoManagedCampaignInfoPayload>;

export const AutoManagedCampaignsList = ({ loading, data = [] }: AutoManagedCampaignsListProps) => {
  const { selectItem, selectedItemIds, hasAllItemsSelected, setSelectedItemIds, toggleSelectAllItems } =
    useSelectItemIds({ allItemIds: data.map((campaign) => campaign.id) });
  const { columns } = useAutoManagedCampaignsTable({
    selectItem,
    selectedItemIds,
    hasAllItemsSelected,
    toggleSelectAllItems
  });

  return (
    <div css={{ position: 'relative' }}>
      <ActionBar
        selectedItemIds={selectedItemIds}
        setSelectedItemIds={setSelectedItemIds}
        hasAllItemsSelected={hasAllItemsSelected}
        toggleSelectAllItems={toggleSelectAllItems}
      />

      <TableV2 data={data} loading={loading} columns={columns} noTopBorderRadius hasBorder />
    </div>
  );
};
